/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

export type BTAdminBuilderPreference =
  (typeof BTAdminBuilderPreference)[keyof typeof BTAdminBuilderPreference];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BTAdminBuilderPreference = {
  notificationHistoryRedesign: "notificationHistoryRedesign",
  estimateCostCodeGroupModifications: "estimateCostCodeGroupModifications",
  jcbMarkupTaxLogicSwitch: "jcbMarkupTaxLogicSwitch",
  qbdAccountingCacheFromGcs: "qbdAccountingCacheFromGcs",
  accountingServiceQboInvoiceSync: "accountingServiceQboInvoiceSync",
  costCodeSettingsAgGrid: "costCodeSettingsAgGrid",
  accountingMfaEnrollmentReason: "accountingMfaEnrollmentReason",
  requireCostCodeAtClockIn: "requireCostCodeAtClockIn",
  subsAuth0Migration: "subsAuth0Migration",
  tasksPunchListAsTag: "tasksPunchListAsTag",
  permissionsMfaEnrollmentCohort: "permissionsMfaEnrollmentCohort",
  updatedRecommendedCostCodes: "updatedRecommendedCostCodes",
  worksheetAGGrid: "worksheetAGGrid",
  estimateMobileServices: "estimateMobileServices",
  sageARPayments: "sageARPayments",
  sageSync: "sageSync",
  paymentMethodUI: "paymentMethodUI",
  internalUserAlwaysEditable: "internalUserAlwaysEditable",
  billsFullPageConversion: "billsFullPageConversion",
  budgetCostCodeCaching: "budgetCostCodeCaching",
  changeOrdersNewItemHeader: "changeOrdersNewItemHeader",
  bulkExport: "bulkExport",
  qbdFlatCostCodeImport: "qbdFlatCostCodeImport",
  selectionOptionHeroImage: "selectionOptionHeroImage",
  sageIntacctMVP: "sageIntacctMVP",
  taskDependencies: "taskDependencies",
  requireNotesAtClockOut: "requireNotesAtClockOut",
  editBillPercentage: "editBillPercentage",
  timeClockLegacyGeneralJobCleanup: "timeClockLegacyGeneralJobCleanup",
  estimateNestedCostCategories: "estimateNestedCostCategories",
  jcbNestedCostCategories: "jcbNestedCostCategories",
  useNotificationsEmail: "useNotificationsEmail",
  selfServiceMfaManagement: "selfServiceMfaManagement",
  selectionsCardView: "selectionsCardView",
  bidQuoteAutofill: "bidQuoteAutofill",
  estimatePlanScanDoorsAndWindows: "estimatePlanScanDoorsAndWindows",
  bidsNotificationUpgradeTier1: "bidsNotificationUpgradeTier1",
  enableProgressInvoiceNotifications: "enableProgressInvoiceNotifications",
  taskGantt: "taskGantt",
  scopeOfWorkMobileCardView: "scopeOfWorkMobileCardView",
  sageBillPayments: "sageBillPayments",
  tasksCustomFieldSortTweaks: "tasksCustomFieldSortTweaks",
  allocateBillCostsAcrossMultipleJobs: "allocateBillCostsAcrossMultipleJobs",
  sageTimeClock: "sageTimeClock",
  costCodeSettingsRedesign: "costCodeSettingsRedesign",
  customForwardEmailAlias: "customForwardEmailAlias",
  partialPaymentLienWaivers: "partialPaymentLienWaivers",
  selectionsReimagined: "selectionsReimagined",
  aIASignatureWorkflow: "aIASignatureWorkflow",
  sageInvoice: "sageInvoice",
  invoiceCalculationTechDebt: "invoiceCalculationTechDebt",
  progressInvoiceRevisedBudgetColumn: "progressInvoiceRevisedBudgetColumn",
  tasksRequireCompletedSubtasks: "tasksRequireCompletedSubtasks",
  xeroReconnectAfterError: "xeroReconnectAfterError",
  aiaPurchaseOrder: "aiaPurchaseOrder",
  disableToDos: "disableToDos",
  useRemoteEmailClassification: "useRemoteEmailClassification",
  selectionsGrouping: "selectionsGrouping",
  lowesInCompanySettings: "lowesInCompanySettings",
  builderAccountSecurity: "builderAccountSecurity",
  infoArchOptIn: "infoArchOptIn",
  schedules2OptIn: "schedules2OptIn",
  selectionsCatalogCreate: "selectionsCatalogCreate",
  newSelectionsNotifications: "newSelectionsNotifications",
  mobileInAppFeedback: "mobileInAppFeedback",
  watchingForTasks: "watchingForTasks",
  billAccountingSyncMoment: "billAccountingSyncMoment",
  offlinePartialBillPaymentsNoAccounting:
    "offlinePartialBillPaymentsNoAccounting",
  progressInvoicePreviousAmountRecalc: "progressInvoicePreviousAmountRecalc",
  invoiceCreationAlignment: "invoiceCreationAlignment",
  requireStepUpAuthForOutboundPayments: "requireStepUpAuthForOutboundPayments",
  tasksCalendarFeed: "tasksCalendarFeed",
  schedulePagedGanttPrint: "schedulePagedGanttPrint",
  mediaUploadCompression: "mediaUploadCompression",
  bidPackageAgentRelease1: "bidPackageAgentRelease1",
  autoFillInvoice: "autoFillInvoice",
  taxesChangeOrders: "taxesChangeOrders",
  estimateActivityLog: "estimateActivityLog",
  billPaymentScheduling: "billPaymentScheduling",
  bulkRoleManagement: "bulkRoleManagement",
  mobileWebviewExperience: "mobileWebviewExperience",
  taskDependenciesShifting: "taskDependenciesShifting",
  paymentsControllerRefactor: "paymentsControllerRefactor",
  multiInvoicePdfSplitDetectionReview: "multiInvoicePdfSplitDetectionReview",
  billRetainageWithBillPay: "billRetainageWithBillPay",
  massEditDueDates: "massEditDueDates",
  invoiceRelatedEntityLineItemTags: "invoiceRelatedEntityLineItemTags",
  invoiceSubtotalBreakdown: "invoiceSubtotalBreakdown",
  billInlinePurchaseOrderLinking: "billInlinePurchaseOrderLinking",
  useBillPoMatching: "useBillPoMatching",
  costInboxMigration: "costInboxMigration",
  disableSubOwnerExternalEmails: "disableSubOwnerExternalEmails",
  upmarketSaleEnablement: "upmarketSaleEnablement",
  selectionsClientReview: "selectionsClientReview",
  taskPhaseDemo: "taskPhaseDemo",
  bidComparisonRelease1: "bidComparisonRelease1",
  qbdWebConnectorHangfireDefer: "qbdWebConnectorHangfireDefer",
  aIEstimate: "aIEstimate",
  aIEstimateChat: "aIEstimateChat",
  aIPreliminaryEstimate: "aIPreliminaryEstimate",
  selectionOptionsLineItemCard: "selectionOptionsLineItemCard",
  enableSpecPublishNotifications: "enableSpecPublishNotifications",
  genericLinkingSpecsToCO: "genericLinkingSpecsToCO",
  specInternalOnlyPublish: "specInternalOnlyPublish",
  fieldNotes: "fieldNotes",
  quickBooksMigrationInvoices: "quickBooksMigrationInvoices",
  specificationGroups: "specificationGroups",
  messagesAllowMobileVideoUploads: "messagesAllowMobileVideoUploads",
  invoiceCustomizationDrawer: "invoiceCustomizationDrawer",
  schedules2Pilot: "schedules2Pilot",
  taskAssistantOptIn: "taskAssistantOptIn",
  improveCustomizationDrawer: "improveCustomizationDrawer",
  taxesSelectionChoices: "taxesSelectionChoices",
  dailyLogsAutoSave: "dailyLogsAutoSave",
  plansAiVersionSummary: "plansAiVersionSummary",
  leadsFullPageConversion: "leadsFullPageConversion",
  splitBillsPOsBudgetSettings: "splitBillsPOsBudgetSettings",
  mobileDirectoryAddExperience: "mobileDirectoryAddExperience",
  whatsNewPanel: "whatsNewPanel",
  massShiftCreation: "massShiftCreation",
  defaultSpcOn: "defaultSpcOn",
  aiPoweredSearch: "aiPoweredSearch",
  offlinePartialBillPaymentsAccounting: "offlinePartialBillPaymentsAccounting",
  invoiceTaxColumnPresentation: "invoiceTaxColumnPresentation",
  convertLegacyTemplateToSRI: "convertLegacyTemplateToSRI",
  specsRelatedItemLinkEnhancements: "specsRelatedItemLinkEnhancements",
  scheduleCompleteInvoiceReadyNotification:
    "scheduleCompleteInvoiceReadyNotification",
  templateSupportForSelectionOptions: "templateSupportForSelectionOptions",
  expenseAccountingSync: "expenseAccountingSync",
  warrantiesModalConversion: "warrantiesModalConversion",
  legacyBuildersSriTemplateSupport: "legacyBuildersSriTemplateSupport",
} as const;
